import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ListFilter } from "lucide-react";

import {
  PageEyebrowLink,
  PageHeader,
  Skeleton,
  Button
} from "@/components/ui";
import {
  ActivityLogsDataTable,
  FormFilterActivityLogs
} from "@/components/common";

import { useFetchActivityLogsQuery, usePermission } from "@/hooks";

export function ActivityLogs() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { checkPermission } = usePermission();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const collaborator = searchParams.get("collaborator");
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const action = searchParams.get("action");

  const { data, refetch, isLoading } = useFetchActivityLogsQuery({
    page,
    collaborator,
    startDate,
    endDate,
    action,
  });

  useEffect(() => {
    if (!checkPermission("role", "view role")) {
      navigate("/")
      return;
    }

    const getLogs = async () => {
      await refetch();
    };

    getLogs();
  }, [page, collaborator, startDate, endDate, action, refetch]);
  return (
    <section className="space-y-6">
      <PageHeader
        eyebrow={
          <PageEyebrowLink to="/settings/account">
            {t("LABEL.settings")}
          </PageEyebrowLink>
        }
        title={t("LABEL.activity logs")}
        lede="Quem alterou o quê no sistema da clínica, com autor, data e hora."
        actions={
          <FormFilterActivityLogs>
            <Button variant="secondary" className="gap-3">
              <ListFilter size={16} aria-hidden="true" /> {t("LABEL.filter")}
            </Button>
          </FormFilterActivityLogs>
        }
      />

      <section>
        {isLoading ? (
          <Skeleton className="w-full h-[70vh]" />
        ) : (
          <>{data && <ActivityLogsDataTable data={data} />}</>
        )}
      </section>
    </section>
  );
}
